import type { WeddingLanguage } from "../types/project";

export const copyByLanguage: Record<WeddingLanguage, Record<string, string>> = {
  id: {
    dear: "Dear",
    weddingOf: "The Wedding of",
    details: "Lihat Detail",
    reservation: "Reservasi",
    maps: "Buka Lokasi",
    groom: "The Groom",
    bride: "The Bride",
    storyEyebrow: "A Love Journey",
    countdown: "Counting Down to",
    days: "Hari",
    hours: "Jam",
    minutes: "Menit",
    seconds: "Detik",
    events: "Wedding Events",
    saveDate: "Save The Date",
    name: "Nama",
    attendance: "Kehadiran",
    guests: "Jumlah yang hadir",
    sendRsvp: "Kirim Reservasi",
    rsvpSuccess: "Terima kasih, RSVP Anda sudah tersimpan di mock admin.",
    ourMoments: "Our Moments",
    openGift: "Buka Halaman Hadiah",
    sendGift: "Kirim Hadiah",
    copyNumber: "Salin Nomor",
    giftHelp: "Silakan pilih rekening tujuan di bawah ini.",
    warmWishes: "Warm Wishes",
    wishesLabel: "Wishes",
    sendWish: "Kirim Wishes",
    wishSuccess: "Wishes tersimpan di mock service.",
    emptyGallery: "Upload gallery di admin preview.",
    emptyWishes: "Belum ada wishes. Jadilah yang pertama meninggalkan doa hangat.",
    musicOn: "Music On",
    musicOff: "Music Off",
    close: "Close",
    previous: "Previous",
    next: "Next Photo",
    save: "Save Photo",
    livestream: "Live Streaming",
    barcode: "Barcode"
  },
  en: {
    dear: "Dear",
    weddingOf: "The Wedding of",
    details: "View Details",
    reservation: "Reservation",
    maps: "Open Location",
    groom: "The Groom",
    bride: "The Bride",
    storyEyebrow: "A Love Journey",
    countdown: "Counting Down to",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    events: "Wedding Events",
    saveDate: "Save The Date",
    name: "Name",
    attendance: "Attendance",
    guests: "Number of guests",
    sendRsvp: "Send Reservation",
    rsvpSuccess: "Thank you, your RSVP has been saved in the mock admin.",
    ourMoments: "Our Moments",
    openGift: "Open Gift Page",
    sendGift: "Send a Gift",
    copyNumber: "Copy Number",
    giftHelp: "Please choose one of the bank accounts below.",
    warmWishes: "Warm Wishes",
    wishesLabel: "Wishes",
    sendWish: "Send Wishes",
    wishSuccess: "Your wish has been saved in the mock service.",
    emptyGallery: "Upload gallery photos in the admin preview.",
    emptyWishes: "There are no wishes yet. Be the first to leave a warm blessing.",
    musicOn: "Music On",
    musicOff: "Music Off",
    close: "Close",
    previous: "Previous",
    next: "Next Photo",
    save: "Save Photo",
    livestream: "Live Streaming",
    barcode: "Barcode"
  },
  zh: {
    dear: "敬邀",
    weddingOf: "我们的婚礼",
    details: "查看详情",
    reservation: "出席回执",
    maps: "打开地图",
    groom: "新郎",
    bride: "新娘",
    storyEyebrow: "爱的旅程",
    countdown: "幸福倒数",
    days: "天",
    hours: "时",
    minutes: "分",
    seconds: "秒",
    events: "婚礼安排",
    saveDate: "敬请留念",
    name: "姓名",
    attendance: "是否出席",
    guests: "出席人数",
    sendRsvp: "提交回执",
    rsvpSuccess: "谢谢您，出席回执已保存到模拟后台。",
    ourMoments: "我们的时刻",
    openGift: "打开礼金页面",
    sendGift: "送上祝福",
    copyNumber: "复制账号",
    giftHelp: "请选择以下收款账户。",
    warmWishes: "温馨祝福",
    wishesLabel: "祝福",
    sendWish: "送出祝福",
    wishSuccess: "祝福已保存到模拟服务。",
    emptyGallery: "请在后台预览中上传相册。",
    emptyWishes: "还没有祝福，欢迎留下第一份美好祝福。",
    musicOn: "音乐开",
    musicOff: "音乐关",
    close: "关闭",
    previous: "上一张",
    next: "下一张",
    save: "保存照片",
    livestream: "婚礼直播",
    barcode: "条码"
  }
};
